var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-question-checkmark 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1171275911"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5645 18.5643C18.7846 17.6156 19.3291 16.7736 20.104 16.1837C20.8789 15.5938 21.8355 15.293 22.8086 15.3334C23.8879 15.2736 24.947 15.6431 25.7549 16.3613C26.5628 17.0794 27.0539 18.0879 27.1211 19.1668C27.1211 22.0492 23.0003 23.0001 23.0003 24.9168",
    stroke: "#111859",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25 30.0026C24.9995 30.3979 24.8818 30.7842 24.6619 31.1127C24.4419 31.4412 24.1295 31.6972 23.7642 31.8483C23.3988 31.9993 22.9969 32.0387 22.6092 31.9614C22.2215 31.8842 21.8653 31.6938 21.5858 31.4142C21.3062 31.1347 21.1158 30.7785 21.0386 30.3908C20.9613 30.0031 21.0007 29.6012 21.1517 29.2358C21.3028 28.8705 21.5588 28.5581 21.8873 28.3381C22.2158 28.1182 22.6021 28.0005 22.9974 28C23.2605 27.9997 23.5211 28.0512 23.7642 28.1518C24.0073 28.2523 24.2282 28.3998 24.4142 28.5858C24.6002 28.7718 24.7477 28.9927 24.8483 29.2358C24.9488 29.4789 25.0003 29.7395 25 30.0026Z",
    fill: "#111859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.87705 32.8865C6.39729 29.347 5.33415 25.0067 5.89741 20.7218C6.46066 16.4369 8.6094 12.5188 11.9197 9.7404C15.2299 6.96202 19.4613 5.5252 23.7789 5.71343C28.0965 5.90166 32.1868 7.70126 35.2427 10.7572C38.2986 13.8131 40.0982 17.9034 40.2865 22.221C40.4747 26.5386 39.0379 30.77 36.2595 34.0802C33.4811 37.3905 29.563 39.5392 25.2781 40.1025C20.9933 40.6658 16.6529 39.6026 13.1134 37.1229L7.66674 38.3332L8.87705 32.8865Z",
    stroke: "#111859",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuest);
export default __webpack_public_path__ + "static/media/quest.4cf8b59c8c4a31f67c7751c0a33e381b.svg";
export { ForwardRef as ReactComponent };